/* EclatDent — fiche accessoire : galerie (clic + swipe), variantes, ajout panier AJAX */
(() => {
  if (window.__edaccInit) return;
  window.__edaccInit = true;

  const root = document.querySelector('[data-edacc]');
  if (!root) return;

  const T = {
    adding: root.dataset.tAdding || 'Ajout…',
    added: root.dataset.tAdded || 'Ajouté ✓',
    error: root.dataset.tError || 'Erreur',
    addFail: root.dataset.tAddFail || "Impossible d’ajouter au panier : ",
    retry: root.dataset.tRetry || 'réessaie dans un instant.',
  };

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty) || 1 }] }),
    }).then((r) => {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then((data) => {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return data;
    });
  }

  // — Galerie : vignettes + swipe sur l'image principale —
  const main = root.querySelector('[data-edacc-main]');
  const mainImg = main ? main.querySelector('img') : null;
  const thumbs = [...root.querySelectorAll('[data-edacc-thumb]')];
  let viewIndex = 0;
  function setView(i) {
    if (!mainImg || !thumbs.length) return;
    viewIndex = (i % thumbs.length + thumbs.length) % thumbs.length;
    thumbs.forEach((b, k) => b.classList.toggle('active', k === viewIndex));
    const src = thumbs[viewIndex].dataset.edaccThumb;
    if (!src || mainImg.src === src) return;
    main.classList.add('is-switching');
    setTimeout(() => {
      mainImg.removeAttribute('srcset'); // la vignette donne une URL 900w : le srcset du premier rendu (LCP) ne doit plus l'emporter
      mainImg.src = src;
      main.classList.remove('is-switching');
    }, 160);
  }
  thumbs.forEach((btn, k) => btn.addEventListener('click', () => setView(k)));
  if (main && thumbs.length > 1) {
    let sx = 0, sy = 0, tracking = false;
    main.addEventListener('touchstart', (e) => {
      const t = e.touches[0];
      if (!t) return;
      sx = t.clientX; sy = t.clientY; tracking = true;
    }, { passive: true });
    main.addEventListener('touchend', (e) => {
      const t = e.changedTouches[0];
      if (!tracking || !t) return;
      tracking = false;
      const dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) setView(viewIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  // — Buy box —
  const buybox = root.querySelector('[data-edacc-buybox]');
  if (buybox) {
    const qtyInput = buybox.querySelector('input[name="quantity"]');
    const idInput = buybox.querySelector('input[name="id"]');
    const addBtn = buybox.querySelector('[data-edacc-add]');
    const select = buybox.querySelector('[data-edacc-variant]');
    const priceEl = root.querySelector('[data-edacc-price]');
    const compareEl = root.querySelector('[data-edacc-compare]');
    const clampQty = (v) => Math.max(1, Math.min(99, parseInt(v, 10) || 1));

    // 03/11 : libellé concret du bouton « Ajouter au panier · prix » (prix de la variante × quantité)
    // Même présentation que le format monétaire de la boutique (« €21,99 ») : on remplace le nombre dans un prix déjà formaté par Shopify
    const money = (cents, modele) => {
      const n = (cents / 100).toFixed(2);
      if (modele && /\d/.test(modele)) {
        const virgule = /\d,\d{2}(?!\d)/.test(modele);
        return modele.replace(/\d[\d\s.,\u00a0\u202f]*\d|\d/, virgule ? n.replace('.', ',') : n);
      }
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cur }).format(cents / 100); }
      catch (e) { return n + ' ' + cur; }
    };
    function libelle() {
      if (!addBtn || !addBtn.dataset.tAdd) return;
      const opt = select ? select.options[select.selectedIndex] : null;
      const dispo = opt ? !opt.disabled : !addBtn.disabled;
      const cents = Number((opt && opt.dataset.cents) || addBtn.dataset.cents || 0);
      const q = clampQty(qtyInput.value);
      const modele = (opt && opt.dataset.price) || addBtn.dataset.price || '';
      const prix = q === 1 && modele ? modele : money(cents * q, modele);
      addBtn.disabled = !dispo;
      // 03/11 (point 6) : badge « Épuisé » de la fiche et bouton « − » inactif à 1
      const badgeEpuise = root.querySelector('[data-ed-badge-epuise]');
      if (badgeEpuise) badgeEpuise.hidden = dispo;
      const moins = buybox.querySelector('[data-delta="-1"]');
      if (moins) moins.setAttribute('aria-disabled', String(q <= 1));
      addBtn.textContent = dispo ? addBtn.dataset.tAdd.replace('__P__', prix) : addBtn.dataset.tSoldout;
    }

    buybox.querySelectorAll('[data-delta]').forEach((b) => b.addEventListener('click', () => {
      qtyInput.value = clampQty(Number(qtyInput.value) + Number(b.dataset.delta));
      libelle();
    }));
    qtyInput.addEventListener('change', libelle);

    if (select) select.addEventListener('change', () => {
      const opt = select.options[select.selectedIndex];
      if (!opt) return;
      idInput.value = opt.value;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl) {
        if (opt.dataset.compare) { compareEl.textContent = opt.dataset.compare; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      libelle();
    });

    buybox.addEventListener('submit', (e) => {
      e.preventDefault();
      const original = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = T.adding;
      addToCart(idInput.value, clampQty(qtyInput.value))
        .then(() => {
          addBtn.textContent = T.added;
          setTimeout(() => { addBtn.disabled = false; addBtn.textContent = original; }, 1600);
        })
        .catch(() => {
          addBtn.disabled = false;
          addBtn.textContent = original;
          alert(T.addFail + T.retry);
        });
    });
  }

  // — Cross-sell dentifrices —
  root.querySelectorAll('[data-edacc-quickadd]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const original = btn.textContent;
      btn.setAttribute('disabled', 'disabled');
      addToCart(btn.dataset.variant, 1)
        .then(() => { btn.textContent = T.added; setTimeout(() => { btn.removeAttribute('disabled'); btn.textContent = original; }, 1500); })
        .catch(() => { btn.textContent = T.error; setTimeout(() => { btn.removeAttribute('disabled'); btn.textContent = original; }, 1600); });
    });
  });
})();
